import Configuracao from '../misc/Configuracao';
import fetch from './AxiosAdapter';
import { Triagem, TriagemCampo, TriagemGrupo } from '../modelo/Triagem';
import { Tema } from '@/modelo/Tema';

class TriagemApi {

    async buscarTriagemGrupo(): Promise<TriagemGrupo[]> {
        const result = await fetch<TriagemGrupo[]>(Configuracao.urlBaseGE + 'temas-api/triagem/grupo');

        return result.data;
    }

    async buscarTriagemCampos(): Promise<TriagemCampo[]> {
        const result = await fetch<TriagemCampo[]>(Configuracao.urlBaseGE + 'temas-api/triagem/campos');

        return result.data;
    }

    async buscarTemas(): Promise<any[]> {
        const result = await fetch<any[]>(Configuracao.urlBaseGE + 'temas-api/temas');

        return result.data;
    }

    async buscarTemasDoProcesso(codProcesso: number): Promise<any> {
        const result = await fetch<number[]>(Configuracao.urlBaseGE + 'temas-api/temas/processo/' + codProcesso);

        return result.data[codProcesso];
    }

    async buscarTriagem(codProcesso: number): Promise<Triagem> {
        const result = await fetch<Triagem>(Configuracao.urlBaseGE + 'temas-api/triagem', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: [codProcesso]
        });

        return result.data;
    }

    async buscarTriagemTodosProcessos(idsProcesso: number[]): Promise<Map<number, Triagem>> {
        const result = await fetch<Map<number, Triagem>>(Configuracao.urlBaseGE + 'api/processos/triagem-pardal', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: idsProcesso
        });

        return result.data;
    }

    async buscarTemasTodosProcessos(idsProcesso: number[]): Promise<Map<number, Tema[]>> {
        const result = await fetch<Map<number, Tema[]>>(Configuracao.urlBaseGE + 'api/processos/temas-pardal', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: idsProcesso
        });

        return result.data;
    }

    async salvarTriagem(triagem: Triagem): Promise<Triagem> {
        const url = Configuracao.urlBaseGE + 'temas-api/triagem';
        const result = await fetch<Triagem>(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: triagem
        });

        return result.data;
    }

    async adicionarTemaProcesso(codTema: number, codProcesso: number): Promise<Triagem> {
        const url = Configuracao.urlBaseGE + 'temas-api/temas/' + codTema + '/processo/' + codProcesso;
        const result = await fetch<Triagem>(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return result.data;
    }

    async removerTemaProcesso(codTema: number, codProcesso: number): Promise<Triagem> {
        const url = Configuracao.urlBaseGE + 'temas-api/temas/' + codTema + '/processo/' + codProcesso;
        const result = await fetch<Triagem>(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return result.data;
    }

    async buscarObices(): Promise<any[]> {
        const result = await fetch<any[]>(Configuracao.urlBaseGE + 'temas-api/obices');

        return result.data;
    }

    async buscarObicesTemasProcesso(idsProcessos: number[]): Promise<any[]> {
        const result = await fetch<any[]>(Configuracao.urlBaseGE + 'temas-api/obices', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: idsProcessos
            });

        return result.data;
    }

    async adicionarObiceTemaProcesso(codTema: number, codProcesso: number, codObice: number): Promise<Triagem> {
        const url = Configuracao.urlBaseGE + 'temas-api/temas/' + codTema + '/processo/' + codProcesso + '/obice/' + codObice;
        const result = await fetch<Triagem>(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return result.data;
    }

    async removerObiceTemaProcesso(codTema: number, codProcesso: number, codObice: number): Promise<Triagem> {
        const url = Configuracao.urlBaseGE + 'temas-api/temas/' + codTema + '/processo/' + codProcesso + '/obice/' + codObice;
        const result = await fetch<Triagem>(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return result.data;
    }


}

export default new TriagemApi();
